const NotificationBellIcon = ({ color }: any) => {
  return (
    <svg width={22} height={22} viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.5 7.334a5.5 5.5 0 00-11 0c0 6.417-2.75 8.25-2.75 8.25h16.5s-2.75-1.833-2.75-8.25zM12.586 19.25a1.832 1.832 0 01-3.172 0'
        strokeWidth={1.75}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default NotificationBellIcon
